import { getEntityTypeConfig } from '../config/entityTypeRegistry';

/**
 * @typedef {{ type: string, id: string }} LinkEndpoint
 */

/**
 * @param {LinkEndpoint} endpointA
 * @param {LinkEndpoint} endpointB
 * @returns {[LinkEndpoint, LinkEndpoint]}
 */
export function canonicalize(endpointA, endpointB) {
  const rankA = getEntityTypeConfig(endpointA.type).sortRank;
  const rankB = getEntityTypeConfig(endpointB.type).sortRank;

  if (rankA < rankB) {
    return [endpointA, endpointB];
  }
  if (rankB < rankA) {
    return [endpointB, endpointA];
  }

  if (endpointA.id <= endpointB.id) {
    return [endpointA, endpointB];
  }
  return [endpointB, endpointA];
}

/**
 * @param {LinkEndpoint} endpointA
 * @param {LinkEndpoint} endpointB
 * @param {string} linkType
 * @returns {string}
 */
export function buildDedupKey(endpointA, endpointB, linkType) {
  const [low, high] = canonicalize(endpointA, endpointB);
  return `${low.type}:${low.id}|${high.type}:${high.id}|${linkType}`;
}

/**
 * Denormalised participant ids for single-query link lookup (array-contains).
 * @param {LinkEndpoint} entityLow
 * @param {LinkEndpoint} entityHigh
 * @returns {string[]}
 */
export function buildParticipantIds(entityLow, entityHigh) {
  return [...new Set([entityLow.id, entityHigh.id])].sort();
}

/**
 * @param {LinkEndpoint} endpoint
 * @returns {void}
 */
export function validateEndpoint(endpoint) {
  if (!endpoint || typeof endpoint !== 'object') {
    throw new Error('Link endpoint must be an object');
  }
  if (!endpoint.type || !endpoint.id) {
    throw new Error('Link endpoint requires type and id');
  }
  getEntityTypeConfig(endpoint.type);
}

/**
 * @param {Object} linkDoc
 * @returns {boolean}
 */
export function isActiveLink(linkDoc) {
  return (linkDoc?.linkLifecycle ?? 'active') === 'active';
}
